import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggle"]
  // Labels are configurable so callers can use their own wording (e.g. "View details"); the defaults
  // preserve the existing "Show details" / "Hide details" behavior for every existing usage.
  static values = {
    showLabel: { type: String, default: "Show details" },
    hideLabel: { type: String, default: "Hide details" },
  }

  initialize() {
    this.isVisible = false;
  }

  toggle() {
    if (this.isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.contentTarget.classList.remove("hidden");
    this.toggleTarget.innerText = this.hideLabelValue;
    this.isVisible = true;
  }

  hide() {
    this.contentTarget.classList.add("hidden");
    this.toggleTarget.innerText = this.showLabelValue;
    this.isVisible = false;
  }
}
